import { render } from "./PasswordResetReminder.vue?vue&type=template&id=6fc861f6&scoped=true"
import script from "./PasswordResetReminder.vue?vue&type=script&lang=js"
export * from "./PasswordResetReminder.vue?vue&type=script&lang=js"

import "./PasswordResetReminder.vue?vue&type=style&index=0&id=6fc861f6&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc861f6"]])

export default __exports__